export function residentworkConfig() {
  return {
    menuType: "button",
    addBtn: false,
    menuWidth: 120,
    menuAlign: "center",
    card: true,
    menu: false,
    refreshBtn: false,
    delBtn: false,
    editBtn: false,
    align: "center",
    searchMenuSpan: 8,
    columnBtn: false,
    searchBtn: true,
    // index: true,
    // indexLabel: "序号",
    selection: true,
    selectionWidth: 45,
    labelWidth: 150,
    column: [
      {
        label: "",
        labelWidth:0,
        prop: "search",
        width: 140,
        search:true,
        hide:true,
        display:false,
        searchPlaceholder:'编号/名称',
        searchLabelWidth:1,
      },
      {
        label: "编号",
        prop: "number",
        width: 140,
        search:false,
        searchPlaceholder:'编号',
        // rules: [{
        //   required: true,
        //   message: "请输入内容",
        //   trigger: "blur",
        // }, ],
        span:14,
        display:false,
        overHidden: true,

      }, {
        label: "名称",
        prop: "name",
        rules: [{
          required: true,
          message: "请输入内容",
          trigger: "blur",
        }, ],
        span:14 ,
        overHidden: true,
      }, {
        label: "附件",
        prop: "file",
        formslot: true,
        width: 200,
        slot:true,
        overHidden: true,
        span:14,
        rules: [{
          required: true,
          message: "请上传附件",
        }, ],
      }, {
        label: "经办人",
        prop: 'createUserName',
        disabled: false,
        display:false,
        overHidden: true,
      }, {
        label: "所属部门",
        prop: 'createDeptName',
        disabled: false,
        display:false,
        overHidden: true,
      },
      {
        label: "更新时间",
        prop: 'updateTime',
        disabled: false,
        display:false,
        overHidden: true,
      },

    ]
  }
}
